import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { Venue } from "../../../model/Venue";

export const INSERT_VENUE = "INSERT_VENUE";

export interface InsertVenueAction extends Action {
  type: typeof INSERT_VENUE;
  data: Partial<Venue>;
  files: File[];
  logo: File | null;
  organization: OrganizationKeyName;
}

export const insertVenueAction = (
  organization: OrganizationKeyName,
  data: Partial<Venue>,
  files: File[] = [],
  logo: File | null
): InsertVenueAction => ({
  type: INSERT_VENUE,
  data,
  files,
  logo,
  organization,
});
